<template>
  <div class="panel-card">
    <div class="panel-card__header">
      <h3 class="panel-card__title">
        {{ $t('OPPORTUNITY_DASHBOARD.STAGE_FUNNEL.TITLE') }}
      </h3>
      <div class="toggle-group">
        <button
          class="toggle-group__option"
          :class="{ 'toggle-group__option--active': mode === 'count' }"
          @click="mode = 'count'"
        >
          {{ $t('OPPORTUNITY_DASHBOARD.STAGE_FUNNEL.QUANTITY') }}
        </button>
        <button
          class="toggle-group__option"
          :class="{ 'toggle-group__option--active': mode === 'value' }"
          @click="mode = 'value'"
        >
          {{ $t('OPPORTUNITY_DASHBOARD.STAGE_FUNNEL.VALUE') }}
        </button>
      </div>
    </div>

    <div v-if="stages.length" class="stage-funnel">
      <div v-for="stage in stages" :key="stage.id" class="stage-funnel__row">
        <span class="stage-funnel__name" :title="stage.name">{{
          stage.name
        }}</span>
        <opportunity-dashboard-progress-bar
          :percentage="percentageFor(stage)"
          :color="stage.color"
        />
        <span class="stage-funnel__amount">{{ displayValueFor(stage) }}</span>
      </div>
    </div>
    <empty-state
      v-else
      :title="$t('OPPORTUNITY_DASHBOARD.STAGE_FUNNEL.TITLE')"
    />
  </div>
</template>

<script>
import EmptyState from 'dashboard/components/widgets/EmptyState';
import { formatCurrencyValue } from 'dashboard/helper/opportunityDashboardHelper';
import OpportunityDashboardProgressBar from './OpportunityDashboardProgressBar.vue';

export default {
  components: { EmptyState, OpportunityDashboardProgressBar },
  props: {
    stages: { type: Array, default: () => [] },
    currency: { type: String, default: 'BRL' },
  },
  data() {
    return { mode: 'count' };
  },
  computed: {
    maxAmount() {
      const amounts = this.stages.map(stage => this.amountFor(stage));
      return Math.max(...amounts, 1);
    },
  },
  methods: {
    amountFor(stage) {
      return this.mode === 'count' ? stage.count : stage.value;
    },
    percentageFor(stage) {
      return (this.amountFor(stage) / this.maxAmount) * 100;
    },
    displayValueFor(stage) {
      return this.mode === 'count'
        ? stage.count
        : formatCurrencyValue(stage.value, this.currency);
    },
  },
};
</script>

<style scoped lang="scss">
.panel-card {
  background: var(--white);
  border: 1px solid var(--s-100);
  border-radius: var(--border-radius-large);
  padding: var(--space-normal);
}

.panel-card__header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: var(--space-normal);
}

.panel-card__title {
  font-size: var(--font-size-default);
  font-weight: var(--font-weight-bold);
  margin: 0;
}

.toggle-group {
  background: var(--s-25);
  border-radius: var(--border-radius-medium);
  display: flex;
  padding: var(--space-micro);
}

.toggle-group__option {
  background: transparent;
  border: none;
  border-radius: var(--border-radius-small);
  color: var(--s-600);
  cursor: pointer;
  font-size: var(--font-size-mini);
  padding: var(--space-micro) var(--space-small);

  &--active {
    background: var(--white);
    color: var(--b-600);
    font-weight: var(--font-weight-bold);
  }
}

.stage-funnel {
  display: flex;
  flex-direction: column;
  gap: var(--space-small);
}

.stage-funnel__row {
  align-items: center;
  display: flex;
  gap: var(--space-small);
}

.stage-funnel__name {
  flex-shrink: 0;
  font-size: var(--font-size-small);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 9rem;
}

.stage-funnel__amount {
  flex-shrink: 0;
  font-size: var(--font-size-small);
  min-width: 4rem;
  text-align: right;
  white-space: nowrap;
}
</style>
